import { TranslateModule } from '@ngx-translate/core';
import {AllModulesComponent} from "./all-modules.component";
import {HeaderComponent} from "../sharing/header/header.component";
import {SidebarComponent} from "../sharing/sidebar/sidebar.component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {InMemoryWebApiModule} from "angular-in-memory-web-api";
import {AllModulesData} from "../../assets/all-modules-data/all-modules-data";
import {AllModulesRoutingModule} from "./all-modules-routing.module";
import {NgModule} from "@angular/core";

@NgModule({
  declarations: [
    AllModulesComponent,
    HeaderComponent,
    SidebarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    InMemoryWebApiModule.forRoot(AllModulesData),
    AllModulesRoutingModule,
    TranslateModule,

  ],
  providers: [
  ]
})
export class AllModulesModule { }
